module.exports = __webpack_public_path__ + "static/media/confirm.fa288fce.png";